import { render, staticRenderFns } from "./lazy-loaded-content.vue?vue&type=template&id=5c8d7af8&scoped=true&"
import script from "./lazy-loaded-content.vue?vue&type=script&lang=js&"
export * from "./lazy-loaded-content.vue?vue&type=script&lang=js&"
import style0 from "./lazy-loaded-content.vue?vue&type=style&index=0&id=5c8d7af8&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8d7af8",
  null
  
)

export default component.exports